<template>
    <div class="order-wrapper" v-loading="loading" element-loading-text="拼命加载中">
        <div class="section-wrapper">
            <order_head :order="orderData" :check_type="check_type"></order_head>
            <el-tabs type="border-card" class="order-detail-section mg20"
                     v-model="activeTab"
                     @tab-click="switchTab"
            >

                <el-tab-pane label="财务信息" name="2">
                    <order_line v-if="orderData.finance" :order.sync="orderData"
                                :tab="params.FINANCE_LINE" :type="orderData.type"></order_line>
                    <div class="userInfo-group" v-else
                         style="text-align:center; font-size:14px; color:#909399;">
                        <el-button type="text" @click="toWrite('finance')">暂无数据,去填写</el-button>
                    </div>
                </el-tab-pane>

                <el-tab-pane  v-if="orderData.type != 1" label="合同附件" name="3">
                    <order_line v-if="orderData.contracts && orderData.contracts.length>0"
                                :order.sync="orderData" :tab="params.CONTRACT_LINE" :type="orderData.type"></order_line>
                    <div class="userInfo-group" v-else
                         style="text-align:center; font-size:14px; color:#909399;">
                        <el-button type="text" @click="toWrite('contract')">暂无数据,去上传</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="orderData.type != 1" label="订单操作日志" name="4">
                    <order_recorder :id="$route.query['id']"></order_recorder>
                </el-tab-pane>

                <el-tab-pane v-if="orderData.type != 1" label="发票/物流修改记录" name="5">
<!--                    <order_recorder :id="$route.query['id']"></order_recorder>-->
                    <order-change-log :order-id="parseInt($route.query['id'])"></order-change-log>
                </el-tab-pane>
            </el-tabs>
                <el-card v-if="orderData"  class="box-card order-detail-section mg20" >
                   <el-row v-if="orderData.createAttachment">
                       附件：
                       <el-row class="userInfo-group" v-for="(item, index) in orderData.createAttachment" :key="item.id">
                           <el-row>
                               <el-col :span="12" class="order-item"><a :href="item.url" target="_blank"><i
                                       class="el-icon-document"></i>{{item.name}}</a></el-col>
                           </el-row>
                       </el-row>
                 </el-row>
                    </el-card>
            <el-card v-if="orderData && orderData.close_audit"  class="box-card order-detail-section mg20" >
                <div slot="header" >
                    <span>关闭详情</span>
                </div>
                <div>
                    <div>申请人：{{orderData.close_exec}}</div>
                    <div>申请时间：{{orderData.close_apply_time?orderData.close_apply_time:orderData.updated_at}}</div>
                    <div>关闭类型：{{orderData.close_type_memo}}</div>
                    <div>关闭原因：{{orderData.close_reason}}</div>
                </div>
                <el-row v-if="orderData.closeAttachment">
                    附件：
                    <el-row class="userInfo-group" v-for="(item, index) in orderData.closeAttachment" :key="item.id">
                        <el-row>
                            <el-col :span="12" class="order-item"><a :href="item.url" target="_blank"><i
                                    class="el-icon-document"></i>{{item.name}}</a></el-col>
                        </el-row>
                    </el-row>
                </el-row>
            </el-card>

            <!-- 审批不通过记录 -->
            <order-audit-log v-if="activeTab == 2" :orderId="id"></order-audit-log>
            <!-- 审批不通过记录 EOF -->

            <!--第三方合作参数-->
            <!--<div class="">-->
            <!--<order_corp :order.sync="orderData"></order_corp>-->
            <!--</div>-->
            <!--产品信息-->
            <product-basic-info v-if="activeTab == 2" :order.sync="orderData"></product-basic-info>
            <!--财务信息-->
            <div v-if="orderData.type !=1 && (activeTab == params.FINANCE_LINE || activeTab==1)">
                <div v-if="orderData.finance">
                    <order_contract_time :order.sync="orderData"></order_contract_time>
                    <order_performance :order.sync="orderData"></order_performance>
                    <order_customer_info :order.sync="orderData"></order_customer_info>
                    <order_scale :order.sync="orderData"></order_scale>
                    <order_plan_pay :order.sync="orderData"></order_plan_pay>
                    <order_refund :order.sync="orderData"></order_refund>
                    <div class="order-detail-section mg20"
                         v-if="orderData.finance && orderData.finance.express && orderData.finance.invoice && orderData.type != params.TYPE_TRY_OUT">
                        <h3>其他信息</h3>
                        <div class="order-userInfo">
                            <order_invoice :order.sync="orderData"></order_invoice>
                            <order_contract_seal :order.sync="orderData" @address-added="handleAddressAdded" @refresh-order="refreshOrder"></order_contract_seal>
                            <order_address :order.sync="orderData" ref="orderAddress"></order_address>
                            <order_logistic :order.sync="orderData"></order_logistic>
                            <order_finance_other :order.sync="orderData"></order_finance_other>
                        </div>
                    </div>
                </div>

                <div v-else-if="activeTab != params.FINANCE_LINE" class="order-detail-section mg20">
                    <h3>财务信息</h3>
                    <div class="userInfo-group"
                         style="text-align:center; font-size:14px; color:#909399;">
                        <el-button type="text" @click="toWrite('finance')" style="color: #409EFF">暂无数据,去填写</el-button>
                    </div>
                </div>
            </div>
            <!--合同附件-->
            <div v-if="orderData.type !=1 && orderData.contracts && (activeTab == params.CONTRACT_LINE || activeTab==1)">
                <order_contract  :order.sync="orderData"></order_contract>
            </div>
        </div>
    </div>
</template>
<script>

    import {OrderMixin} from "~/services/OrderMixin";
    import Params from "~/config/params";
    import Order_progress from "~/views/order/partial/order_progress.vue";
    import order_corp from "~/views/order/partial/order_corp.vue";
    import Order_product from "~/views/order/partial/order_product.vue";
    import order_contract from "~/views/order/partial/order_contract.vue";
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    import order_address from "~/views/order/partial/order_address.vue";
    import order_logistic from "~/views/order/partial/order_logistic.vue";
    import order_plan_pay from "~/views/order/partial/order_plan_pay.vue";
    import order_customer_info from "~/views/order/partial/order_customer_info.vue";
    import order_performance from "~/views/order/partial/order_performance.vue";
    import order_line from "~/views/order/partial/order_line.vue";
    import order_finance_other from "~/views/order/partial/order_finance_other.vue";
    import order_contract_time from "~/views/order/partial/order_contract_time.vue";
    import order_recorder from "~/views/order/recoder/order.vue";
    import OrderAuditLog from "~/views/order/approve/OrderAuditLog.vue";
    import OrderChangeLog from "~/views/order/recoder/OrderChangeLog.vue";
    import order_scale from "~/views/order/partial/order_scale.vue";
    import order_refund from "~/views/order/partial/order_refund.vue";
    import order_contract_seal from "~/views/order/partial/order_contract_seal.vue";

    export default {
        mixins: [OrderMixin],
        data() {
            return {};
        },
        components: {
            order_recorder,
            Order_product,
            Order_progress,
            order_contract,
            order_invoice,
            order_address,
            order_logistic,
            order_plan_pay,
            order_customer_info,
            order_performance,
            order_line,
            order_corp,
            order_finance_other,
            order_contract_time,
            OrderAuditLog,
            OrderChangeLog,
            order_scale,
            order_refund,
            order_contract_seal
        },

        created() {
        },

        methods: {
            handleAddressAdded(addressData) {
                // 当地址添加成功后，直接更新地址列表数据
                if (this.orderData && this.orderData.finance && this.orderData.finance.express) {
                    this.orderData.finance.express.push(addressData);
                }
            },
            refreshOrder() {
                this.getOrder(this.id);
            }
        },
        
        mounted() {
            this.params = Params;
            this.$nextTick(function () {
                this.getOrder(this.id);
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/approve/view.vue